import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleYearEditor = ({
  tradeId,
  initialYear,
}: {
  tradeId: Trade['id'];
  initialYear: number;
}) => {
  const [year, setYear] = useState(initialYear?.toString() || '');

  const updateYearMutation = useMutation({
    onMutate: async ({ year }: { year: number }) => {
      tradesStore.updateTrade(tradeId, {
        year: year,
      });
    },
    mutationFn: async ({ year }: { year: number }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/year`,
        // /api/trades/:trade_id/year
        {
          year,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating mileage', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleYearChange = useCallback(
    debounce((newYear: number) => {
      updateYearMutation.mutate({ year: newYear });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (year === (initialYear?.toString() || '')) return;

    const parsedYear = parseInt(year);

    if (isNaN(parsedYear)) return;
    if (parsedYear < 1000) return;

    handleYearChange(parsedYear);
  }, [year]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) return;

    setYear(e.target.value);
  }, []);

  useEffect(() => {
    setYear(initialYear?.toString() || '');
  }, [initialYear]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">Year</div>
      </div>
      <InlineTextInput
        value={year?.toString()}
        onChange={onChange}
        placeholder="Enter year"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleYearEditor;
